import { render, staticRenderFns } from "./results-scenario-compare.vue?vue&type=template&id=2375a033&scoped=true"
import script from "./results-scenario-compare.vue?vue&type=script&lang=ts"
export * from "./results-scenario-compare.vue?vue&type=script&lang=ts"
import style0 from "./results-scenario-compare.vue?vue&type=style&index=0&id=2375a033&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2375a033",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2375a033')) {
      api.createRecord('2375a033', component.options)
    } else {
      api.reload('2375a033', component.options)
    }
    module.hot.accept("./results-scenario-compare.vue?vue&type=template&id=2375a033&scoped=true", function () {
      api.rerender('2375a033', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/results/sections/results-scenario-compare.vue"
export default component.exports